export const PROFILE_PATH = '/-/settings/profile';
